import ServerErrorModule from './server-error.module'

export default ServerErrorModule
